import type { ProductEan } from '@@partner:types:app'

import React, { SyntheticEvent } from 'react'
import { useValidatableForm } from '@@partner:helpers/hooks/rsuite'
import { ProductEansManagerValidationModel } from './ProductEansManagerValidationModel'

import { Button, Tag, Form } from 'rsuite'
import IconPlus from '@rsuite/icons/Plus'

export interface ProductEansManagerProps {
  value: ProductEan[]
  onChange: (eans: ProductEan[]) => void
}

export default function ProductEansManager ({
  value = [],
  onChange
}: ProductEansManagerProps) {
  const { formRef, formState, setFormRef, handleFormChange, resetForm } =
    useValidatableForm({
      newEan: '',
      isNonUnique: false
    })

  const handleEanDeleted = (ean: string) => {
    const newValue = value.filter((eanObj) => eanObj.ean !== ean)
    onChange?.(newValue)
  }

  const handleChange = (data: any) => {
    const { newEan } = data
    const isNonUnique = !!newEan
      ? value.find(({ ean }) => ean === newEan) !== undefined
      : false

    handleFormChange({ ...data, isNonUnique })
  }

  const handleAddEan = (e: SyntheticEvent) => {
    e.preventDefault()
    e.stopPropagation()

    if (formRef.current?.check?.()) {
      onChange(value.concat({ ean: formState.newEan }))
      resetForm()
    }
  }

  return (
    <div>
      {value.map((eanObj, key) => (
        <div key={key}>
          <Tag className='my-2' closable onClose={() => handleEanDeleted(eanObj.ean)}>
            {eanObj.ean}
          </Tag>
        </div>
      ))}

      <Form
        ref={setFormRef}
        formValue={formState}
        onChange={handleChange}
        onSubmitCapture={handleAddEan}
        model={ProductEansManagerValidationModel}
      >
        <Form.Control name="newEan" placeholder="Введите новый EAN код" />
        <div>
          <Button className='my-2' color="violet" appearance="primary" size="xs" type="submit">
            <IconPlus /> Добавить
          </Button>
        </div>
      </Form>
    </div>
  )
}
